export default "__VITE_ASSET__D_CDh5Ba__"